export interface ProductMenuItem {
  label: string
  href?: string // omitted = coming soon (disabled, non-navigating)
}

export interface ProductMenuGroup {
  label: string
  href?: string // optional group/category link
  items: ProductMenuItem[]
}

export const PRODUCTS_HREF = 'https://www.6gtools.com/#ProductsMenu'

export const PRODUCT_GROUPS: ProductMenuGroup[] = [
  {
    label: 'Milling',
    items: [
      {
        label: 'End Mills',
        href: 'https://www.6gtools.com/milling/end-mills.html',
      },
      {
        label: 'Carbide End Mills',
        href: 'https://www.6gtools.com/milling/end-mills/carbide.html',
      },
      {
        label: 'Carbide Burrs',
        href: 'https://www.6gtools.com/milling/carbide-burrs.html',
      },
      { label: 'Routers' },
      { label: 'Keyseat Cutters' },
      { label: 'Slitting Saws' },
    ],
  },
  {
    label: 'Hole Making',
    items: [
      {
        label: 'Drill Bits',
        href: 'https://www.6gtools.com/holemaking/drill-bits.html',
      },
      {
        label: 'Carbide Drill Bits',
        href: 'https://www.6gtools.com/82m8/drill-bits/carbide-drill-bits.html',
      },
      {
        label: 'Cobalt Drill Bits',
        href: 'https://www.6gtools.com/82m8/drill-bits/cobalt-drill-bits.html',
      },
      {
        label: 'HSS Drill Bits',
        href: 'https://www.6gtools.com/82m8/drill-bits/hss-drill-bits.html',
      },
      { label: 'Reamers' },
      { label: 'Countersinks' },
    ],
  },
  {
    label: 'Thread Making',
    items: [{ label: 'Thread Mills' }, { label: 'Taps' }, { label: 'Dies' }],
  },
  {
    label: 'Metal Working Fluids',
    items: [
      {
        label: 'Machining Coolants',
        href: 'https://www.6gtools.com/metal-working-fluids/machining-coolants.html',
      },
      { label: 'Rust Inhibitors' },
    ],
  },
  {
    label: 'Brands',
    href: 'https://www.6gtools.com/63.html',
    items: [
      { label: 'Titan USA', href: 'https://www.6gtools.com/brands/titan.html' },
      { label: 'Harvey Tool' },
      { label: 'M A Ford' },
    ],
  },
]
